<template>
    <div>
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <router-link :to="{name:'account'}" class="headerButton">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </router-link>
            </div>
            <div class="pageTitle">Tentang {{ VUE_ENV.VUE_APP_NAME }}</div>
        </div>
        <div id="appCapsule">
            <div class="section mt-4 mr-2 ml-2">
                <!-- <div class="wide-block pt-2 pb-2"> -->
                    <div class="text-center">
                        <img class="w-50" :src="require('@/assets/image/logo_header_color.png')">
                        <p class="text-justify mt-3" style="font-size:13px;line-height:normal;">{{ setting.description }}</p>
                    </div>
                    <table style="width:100%;font-size:13px;line-height:normal;">
                        <tr>
                            <td class="text-nowrap" style="vertical-align:top;width:100px;">Nama Merek</td>
                            <td style="width:15px;">:</td>
                            <td>{{ setting.name_server}}</td>
                        </tr>
                        <tr>
                            <td class="text-nowrap" style="vertical-align:top;">Tagline</td>
                            <td>:</td>
                            <td>Kios Digital Masa Kini</td>
                        </tr>
                        <!-- <tr>
                            <td class="text-nowrap" style="vertical-align:top;">Legalitas</td>
                            <td>:</td>
                            <td>CV. QIOSFIN KREASI INDONESIA</td>
                        </tr> -->
                        <tr>
                            <td class="text-nowrap" style="vertical-align:top;">Email</td>
                            <td>:</td>
                            <td>{{ setting.email}}</td>
                        </tr>
                        <tr>
                            <td class="text-nowrap" style="vertical-align:top;">Website</td>
                            <td>:</td>
                            <td>https://qiosfin.com</td>
                        </tr>
                        <tr>
                            <td class="text-nowrap" style="vertical-align:top;">Alamat</td>
                            <td class="align-top">:</td>
                            <td style="line-height:normal;">{{ setting.address}}</td>
                        </tr>
                    </table>
                    <!-- <dt>Email : {{ setting.email}}</dt>
                    <dt>Chat WhatsApp : {{ setting.phone}}</dt> -->
                <!-- </div> -->
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    computed: {
        ...mapState(['setting','VUE_ENV'])
    },
}
</script>